import React from 'react'
import { Link } from 'react-router-dom'
import { FaArrowAltCircleLeft } from 'react-icons/fa';
import './stylesheets/navbar.css'

export default function ChatNavbar() {
  return (
    <div id='ChatNavbarWrapper' style={{position:'absolute',  padding:'1%', borderBottomRightRadius:40, width:'7.5svh'}}>
        <Link id='ReturnNavbar' style={{textDecoration:'none', display:'flex', alignItems:'center', gap:'5%' }} to = './'>
        <FaArrowAltCircleLeft id='ChatNavbarText' size={20}/>
        {/* <h4 id='ChatNavbarText'>Return</h4> */}
        </Link>
    </div>
  )
}